var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "sidebar-content-wrapper"
    }
  }, _vm._l(_vm.menu, function (item) {
    return _c('SidebarMenuItem', {
      key: `${item.id}-${item.title}`,
      attrs: {
        "item": item,
        "collapse": _vm.isRouteCollapsed(item)
      }
    });
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }